"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerFeature = void 0;
const react_1 = __importDefault(require("react"));
const DatePickerView_1 = require("../../components/DatePickerView");
const hooks_1 = require("../../hooks");
const DateManagement_1 = require("../../utils/DateManagement");
const TAAErrorBoundary_1 = require("../../components/Shared/TAAErrorBoundary");
const consts_1 = require("../../consts");
const DatePickerFeature = ({ selectedDateTime, updateDateAction, associateInfo, featureGates = {
    isDeleteDupePunchEnabled: false,
    isPunchCorrectionEnabled: false,
    isATPlusTemporalRoutingEnabled: false
}, legendFlags = {
    shouldShowScheduledShifts: false,
    shouldShowPayDay: false
} }) => {
    var _a, _b;
    (0, DateManagement_1.setTimeZone)(associateInfo.timeZone);
    const { selectedDate, timeRange } = (0, hooks_1.useDateQueryParams)(selectedDateTime);
    const usageLocation = consts_1.featureNames.DATE_PICKER_FEATURE;
    const { isLoading: isPunchesLoading, data: punches } = (0, hooks_1.usePunches)({
        employeeId: associateInfo.employeeId,
        timeRange,
        isEligibilityEnabled: featureGates.isDeleteDupePunchEnabled,
        usageLocation,
        temporalRouting: featureGates.isATPlusTemporalRoutingEnabled
    });
    const { isLoading: isPayPeriodsLoading, data: { pay_period_breakdown_info } = {} } = (0, hooks_1.usePayPeriod)({
        employeeId: associateInfo.employeeId,
        shouldFetch: featureGates.isDeleteDupePunchEnabled ||
            featureGates.isPunchCorrectionEnabled,
        usageLocation
    });
    const { isLoading: isPunchCorrectionsLoading, data: { punchCorrections } = {} } = (0, hooks_1.usePunchCorrections)({
        employeeId: associateInfo.employeeId,
        timeRange: {
            start: (_a = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current.start_time) !== null && _a !== void 0 ? _a : '',
            end: (_b = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current.end_time) !== null && _b !== void 0 ? _b : ''
        },
        shouldFetch: featureGates.isPunchCorrectionEnabled &&
            !!(pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current),
        usageLocation
    });
    const { isLoading: isPayCalendarLoading, payCalendar } = (0, hooks_1.usePayCalendar)({
        employeeId: associateInfo.employeeId,
        timeRange,
        usageLocation
    });
    const { isLoading: isScheduleLoading, data: schedule } = (0, hooks_1.useSchedule)({
        employeeId: associateInfo.employeeId,
        timeRange,
        usageLocation,
        temporalRouting: featureGates.isATPlusTemporalRoutingEnabled
    });
    const daysWithAttention = (0, hooks_1.useDaysWithAttention)({
        punchCorrections: punchCorrections,
        getPunchesResponse: punches
    });
    const daysWithPunches = (0, hooks_1.useDaysWithPunches)({ punches });
    const daysWithPayDays = (0, hooks_1.useDaysWithPayDays)({
        payCalendar,
        futureDateOnly: true
    });
    const daysWithShifts = (0, hooks_1.useDaysWithShifts)({ schedule });
    return (react_1.default.createElement(TAAErrorBoundary_1.TAAErrorBoundary, null,
        react_1.default.createElement(DatePickerView_1.DatePickerView, { selectedDate: selectedDate, updateDateAction: updateDateAction, isLoading: isPunchesLoading ||
                isPayPeriodsLoading ||
                isPunchCorrectionsLoading ||
                isPayCalendarLoading ||
                isScheduleLoading, daysWithPunches: daysWithPunches, daysWithAttention: daysWithAttention, daysWithPayDays: legendFlags.shouldShowPayDay ? daysWithPayDays : null, daysWithShifts: legendFlags.shouldShowScheduledShifts ? daysWithShifts : null, locale: associateInfo.locale })));
};
exports.DatePickerFeature = DatePickerFeature;
